module.exports = __webpack_public_path__ + "static/media/info-sep.2cd19bff.png";